import enviro from 'enviro';
import { getFullUrl } from 'hubspot-url-utils';
import PortalIdParser from 'PortalIdParser';
import { stringify } from 'hub-http/helpers/params';

export const getVideoManagementEmbedBaseUrl = () => {
  const fullUrl = getFullUrl(enviro.deployed() ? 'app' : 'local');
  const portalId = PortalIdParser.get();
  return `${fullUrl}/videos-iframe/${portalId}`;
};

export const getClipEditorEmbedBaseUrl = (projectId: number) => {
  const fullUrl = getFullUrl(enviro.deployed() ? 'app' : 'local');
  const portalId = PortalIdParser.get();

  let params = { detailsPage: 'new', referrerApp: undefined };

  try {
    const referrerApp = (window.hubspot as any).bender.currentProject;
    params = { ...params, referrerApp };
    if (referrerApp) {
      return `${fullUrl}/content-clip-editor/${portalId}/iframe/project/${projectId}?${stringify(
        params
      )}`;
    } else {
      throw new Error('No referrer app found');
    }
  } catch {
    return `${fullUrl}/content-clip-editor/${portalId}/iframe/project/${projectId}?${stringify(
      params
    )}`;
  }
};

export const getClipEditorNewProjectEmbedUrl = () => {
  const fullUrl = getFullUrl(enviro.deployed() ? 'app' : 'local');
  const portalId = PortalIdParser.get();

  let params = { detailsPage: 'new', referrerApp: undefined };

  try {
    const referrerApp = (window.hubspot as any).bender.currentProject;
    params = { ...params, referrerApp };
  } catch {
    // window.hubspot.bender unavailable; proceed without referrerApp
  }

  return `${fullUrl}/content-clip-editor/${portalId}/iframe/new-project?${stringify(
    params
  )}`;
};
